import { useSuspenseQuery } from "@apollo/client/react";

import { GetGroupsDocument, type GetGroupsQuery, type GetGroupsQueryVariables } from "~/features/admin/groups/gqls";

/**
 * Loads the full group list. GetGroups is tenant-scoped server-side via the
 * Hasura session (no `tenantId` variable), so the whole list is fetched at once
 * and filtered / paginated client-side — V1 parity. The detail view reads the
 * same query and finds its group by id, matching V1.
 */
export function useGroupList() {
  return useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, {
    fetchPolicy: "cache-and-network",
  });
}
